import React from 'react';
import SegmentTime from './SegmentTime';

export interface DepartureTimeProps {
  departureDate: string;
}

const DepartureTime: React.FC<DepartureTimeProps> = ({ departureDate }) => (
  <SegmentTime date={departureDate} />
);

export default DepartureTime;
